import React, { useState, useEffect, useRef, useCallback } from 'react';
import BotonBuscarChico from '../UI/botones/BotonBuscarChico.js';
import CampoComboPais from '../UI/campos/CampoComboPais.js';
import CampoEditableTexto from '../UI/campos/CampoEditableTexto.js';
import PopupCancelable from '../UI/PopupCancelable.js';
import { encontrarIdNumber, EsArrayVacio } from '../funciones/FuncionesArray.js';
import * as Data from '../data/DataClubes.js';
import styles from './PopupBuscarClub.module.css';

const PopupBuscarClub = (props) => {
  const prefiltro = props.prefiltro || Data.PreFiltro.TODOS;
  const objetoFiltro = props.objetoFiltro || null;
  const visible = props.visible;
  const textoIn = props.texto;
  const paisIn = props.pais;
  const paisInicial = props.paisInicial;
  const [clubFocus, setClubFocus] = useState(null);
  const [paisBuscar, setPaisBuscar] = useState(null);
  const [textoBuscar, setTextoBuscar] = useState(null);
  const [clubes, setClubes] = useState(null);
  const buttonReferences = useRef([]);

  const onClickBuscar = () => {
    buscarClubes(paisBuscar, textoBuscar);
  };

  const buscarClubes = useCallback(
    async (pais, texto) => {
      if (busquedaHabilitada(texto, pais)) {
        const result = await Data.GetClubes(prefiltro, objetoFiltro, pais, texto);
        if (result !== undefined && result !== null) {
          setClubes(result);
        }
      } else {
        setClubes(null);
      }
    },
    [prefiltro, objetoFiltro]
  );

  const busquedaHabilitada = (texto, pais) => {
    return (texto && texto.length >= 3) || (pais && pais.id && pais.id !== '');
  };

  // efecto para cargar la lista si vienen valores precargados
  useEffect(() => {
    const esClubesVacio = () => {
      return EsArrayVacio(clubes) || clubes === null || clubes.length === 0;
    };

    if (visible === true && esClubesVacio() && (textoIn || paisIn)) {
      setTextoBuscar(textoIn);
      setPaisBuscar(paisIn);
      buscarClubes(paisIn, textoIn);
    } else if (visible === true && esClubesVacio() && paisInicial) {
      setPaisBuscar(paisInicial);
    }
  }, [visible, paisIn, paisInicial, textoIn, buscarClubes, clubes]);

  const vaciarForm = () => {
    setClubes(null);
    setClubFocus(null);
  };

  const onCampoChange = (nombre, valor) => {
    setTextoBuscar(valor);
    setClubFocus(null);
  };

  const onPaisElegido = (nombre, paisElegido) => {
    if (paisElegido && paisElegido.id && paisElegido.id !== '') {
      setPaisBuscar(paisElegido);
      buscarClubes(paisElegido, textoBuscar);
    } else {
      setPaisBuscar(null);
      buscarClubes(null, textoBuscar);
    }
  };

  const clubClickHandler = (event) => {
    event.preventDefault();
    const club = encontrarIdNumber(clubes, event.target.id);
    if (club) {
      props.onClubElegido(club);
      vaciarForm();
    }
  };

  const clubFocusHandler = (club) => {
    setClubFocus(club);
  };

  const onAceptar = () => {
    if (clubFocus) {
      props.onClubElegido(clubFocus);
      vaciarForm();
    } else {
      alert('Seleccione un club');
    }
  };

  const onCancelar = () => {
    props.onCancelar();
    vaciarForm();
  };

  // debug log removed

  let lista = [];
  if (clubes) {
    for (const clube of clubes) {
      lista = [...lista, clube];
      if (lista.length === 10) {
        break;
      }
    }
  }

  const mensajeListaVacia = () => {
    return busquedaHabilitada(textoBuscar, paisBuscar) && clubes && clubes.length === 0
      ? 'No se encontraron clubes'
      : 'Ingrese al menos tres caracteres del nombre o seleccione un país para buscar';
  };

  return (
    <PopupCancelable
      visible={visible}
      texto=""
      height="18rem"
      width="28rem"
      mostrarEliminar={false}
      isGrabando={false}
      onAceptar={onAceptar}
      onCancelar={onCancelar}
    >
      <div className={`${styles.cuadroBusqueda}`}>
        <div className={`${styles.filaBusqueda}`}>
          <span className={`${styles.textoBusqueda}`}>Nombre:</span>
          <CampoEditableTexto
            nombre="buscar"
            valor={textoBuscar}
            largo={50}
            editar={true}
            estilo={`${styles.campoNombre}`}
            onChange={onCampoChange}
            onPressEnter={onClickBuscar}
          />
        </div>
        <div className={`${styles.filaBusqueda}`}>
          <span className={`${styles.textoBusqueda}`}>País:</span>
          <CampoComboPais
            nombre={'pais'}
            valor={paisBuscar}
            editar={true}
            incluirNulo={true}
            estilo={`${styles.campoPais}`}
            onChange={onPaisElegido}
          />
          <BotonBuscarChico estilo={`${styles.boton}`} onClick={onClickBuscar}></BotonBuscarChico>
        </div>
      </div>
      <div className={`${styles.listaClubes}`}>
        {lista.length === 0 && (
          <span className={`${styles.listaVacia}`}>{mensajeListaVacia()}</span>
        )}
        <ul>
          {lista.map((club, index) => (
            <li key={club.id} id={club.id}>
              <button
                className={`${styles.itemClub}`}
                key={club.id}
                ref={(element) => (buttonReferences.current[index] = element)}
                id={club.id}
                onClick={clubClickHandler}
                onFocus={() => clubFocusHandler(club)}
              >
                {club.nombre + (!paisBuscar && club.pais ? ' (' + club.pais.nombre + ')' : '')}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </PopupCancelable>
  );
};

export default PopupBuscarClub;
